interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="51"
    viewBox="0 0 44 51"
    fill="none"
  >
    <path
      d="M36.3174 48.0205C40.2636 46.3747 42.1376 41.8197 40.503 37.8466C38.8685 33.8735 34.3443 31.9867 30.3982 33.6324C26.452 35.2782 24.578 39.8332 26.2126 43.8063C27.8471 47.7795 32.3712 49.6662 36.3174 48.0205Z"
      stroke={color}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M30.9385 40.8027L32.9105 42.5814L35.7658 39.0654"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4571 9.54164C19.4571 4.81581 15.6672 1 10.9837 1C6.30021 1 2.5 4.81581 2.5 9.54164C2.5 14.2675 6.30021 18.0833 10.9837 18.0833C15.6672 18.0833 19.4674 14.2571 19.4674 9.54164H19.4571Z"
      stroke={color}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M15.5845 13.7509C15.112 12.7478 14.3725 11.6103 13.2119 10.4521"
      stroke={color}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M8.8268 10.4521C7.60457 11.6827 6.84453 12.8823 6.37207 13.9164"
      stroke={color}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M11.0141 11.5273C12.6266 11.5273 13.9413 10.1002 13.9413 8.34224C13.9413 6.58428 12.6369 5.15723 11.0141 5.15723C9.39131 5.15723 8.08691 6.58428 8.08691 8.34224C8.08691 10.1002 9.39131 11.5273 11.0141 11.5273Z"
      stroke={color}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M40.3272 14.4121V22.2712C40.3272 23.5328 38.9509 24.5463 37.2665 24.5463H22.1992"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 38.7651V27.752C1 25.9837 2.36602 24.5566 4.06071 24.5566H28.3204"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 27.5664V38.5795C1 40.3478 2.36602 41.7749 4.06071 41.7749H22.2149"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.3269 22.5503V11.5372C40.3269 9.76885 38.9609 8.3418 37.2662 8.3418H23"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVG;
